module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    class: ['page-header-wide', _vm.layout]
  }, [(this.$route.meta.fullPageContent === false) ? _c('div', {
    staticClass: "breadcrumb"
  }, [_c('a-breadcrumb', _vm._l((_vm.breadcrumb), function(item, index) {
    return _c('a-breadcrumb-item', {
      key: item.path
    }, [(index === 0) ? _c('span', [_c('router-link', {
      attrs: {
        "to": "/"
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _c('span', [_vm._v(_vm._s(item.name))])])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-67a98226","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/common/PageContent.vue
// module id = 22VJ
// module chunks = 273